export default __webpack_public_path__ + "static/media/trim.d0fa1491.jpeg";